export default __webpack_public_path__ + "static/media/sz.86d9e360.svg";